import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import './Login.css';
import balumIcon from '../../src/assets/icons/balum-icon-transparent.png';

const Login = () => {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    // Simulate a small delay for better UX
    setTimeout(() => {
      const success = login(username.trim(), password);
      if (!success) {
        setError('Usuário ou senha incorretos');
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    }, 300);
  };

  const handleVisitorLogin = () => {
    setError('');
    setIsLoading(true);

    // Simulate a small delay for better UX
    setTimeout(() => {
      const success = login('visitante', 'visitante');
      if (!success) {
        setError('Erro ao entrar como visitante');
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    }, 300);
  };

  return (
    <div className="login-container">
      <div className="login-card">
        {/* Logo */}
        <div className="login-logo">
          <img src={balumIcon} alt="balum" className="logo-img" />
        </div>

        {/* Welcome Message */}
        <div className="welcome-section">
          <h1 className="welcome-title">Olá!!!</h1>
          <p className="welcome-subtitle">
            Faça login para acessar o editor de Histórias em Quadrinhos Inclusivas
          </p>
        </div>

        {/* Login Form */}
        <form onSubmit={handleSubmit} className="login-form">
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="username" className="form-label">
              USUÁRIO
            </label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="form-input"
              placeholder=""
              autoComplete="username"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password" className="form-label">
              SENHA
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="form-input"
              placeholder=""
              autoComplete="current-password"
              required
            />
          </div>

          <button
            type="submit"
            className="login-button"
            disabled={isLoading}
          >
            {isLoading ? 'Entrando...' : 'ENTRAR'}
          </button>
        </form>

        {/* Visitor Access */}
        <div className="visitor-access">
          <div className="visitor-divider">
            <span>ou</span>
          </div>
          <button
            type="button"
            onClick={handleVisitorLogin}
            className="visitor-button"
            disabled={isLoading}
          >
            {isLoading ? 'Entrando...' : 'ENTRAR COMO VISITANTE'}
          </button>
          <p className="visitor-note">
            Acesso somente para visualização
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
